import React from 'react';

export const MobileIcon = ({ color }) => (
  <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24" fill={color}>
    <path d="M0 0h24v24H0z" fill="none" />
    <path d="M7 1h10c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H7c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2zm5 20c.83 0 1.5-.67 1.5-1.5S12.83 18 12 18s-1.5.67-1.5 1.5S11.17 21 12 21zm5-4H7V5h10v12z" />
  </svg>
);
